import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import {
  gridColumns_demandPayoff,
  gridColumns_demandPayoff_Borrower,
} from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayoffDemands } from "../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../hooks/useAbortController";
import classes from "../../pages/ReportsNDocuments/reports.module.css";
import { LiHandleButton } from "../../Utils/CustomComponent";
import { FaHandshake } from "react-icons/fa";
import { Button } from "react-bootstrap";
import RequestPayOffModalLender from "../Ticket/RequestPayoffModalLender";
import RequestPayOffModal from "../Borrowers/BorrowerDashboardTwo/RequestPayOffModal";

const DemandPayoff = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const data = useSelector((state) => state.dashboard.payOffDemands.data);
  const status = useSelector((state) => state.dashboard.payOffDemands.status);
  const user = useSelector((state) => state.RS_Authentication.user);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const pendingLenderApproval = useSelector((state) => state.dashboard.pendingLenderApproval);

  const isRoc = selectedAccount?.databasename === "ROC";
  const PendingApproval =
    data?.filter((el) => el.status === "Pending Lender Approval") || [];

  const Approved = data?.filter((el) => el.status === "Approved") || [];
  const Rejected = data?.filter((el) => el.status === "Rejected") || [];
  const Requested = data?.filter((el) => el.status === "Pending") || [];

  const dispatch = useDispatch();
  const { signal } = useAbortController();

  useEffect(() => {
    dispatch(
      fetchPayoffDemands({
        email: user?.details?.email,
        signal,
        selectedRole,
      }),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Demand Payoff Loans" />,
      role: ["Both"],
      className: "col-sm-6 px-5",
    },
    {
      component: (
        <Button
          className="text-white create-ticket"
          onClick={() => setShowModal(true)}
        >
          <FaHandshake className="me-3" /> Request Payoff
        </Button>
      ),
      // role: ["Both"],
      className: `col-sm-6 px-5 text-end ${isRoc ? "d-none" : ""}`,
    },
    // {
    //   component: (
    //     <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
    //       <CommonGrid
    //         className={classes.pastDue25}
    //         title={"Payoff Pending Lender Approval"}
    //         gridColumns={gridColumns_demandPayoff}
    //         columnData={PendingApproval}
    //         status={status}
    //       />
    //     </section>
    //   ),
    //   role: ["Both"],
    //   className: "col-sm-12 px-4",
    // },
    // {
    //   component: (
    //     <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
    //       <CommonGrid
    //         className={classes.pastDue25}
    //         title={"Approved Payoff"}
    //         gridColumns={gridColumns_demandPayoff}
    //         columnData={Approved}
    //         status={status}
    //       />
    //     </section>
    //   ),
    //   role: ["Both"],
    //   className: "col-sm-12 px-4",
    // },
    // {
    //   component: (
    //     <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
    //       <CommonGrid
    //         className={classes.pastDue25}
    //         title={"Rejected Payoff"}
    //         gridColumns={gridColumns_demandPayoff}
    //         columnData={Rejected}
    //         status={status}
    //       />
    //     </section>
    //   ),
    //   role: ["Both"],
    //   className: "col-sm-12 px-4",
    // },
    {
      component: (
        <div>
          <ul className="nav nav-tabs my-5">
            {tabButtons(selectedRole).map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={setActiveTab}
                flash={
                  selectedRole === "L" &&
                  pendingLenderApproval > 0 &&
                  index === 1
                }
                count={
                  selectedRole === "L" &&
                  pendingLenderApproval > 0 &&
                  index === 1
                    ? pendingLenderApproval
                    : 0
                }
              />
            ))}
          </ul>

          <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
            {activeTab === 0 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Requested Payoff"}
                gridColumns={
                  selectedRole === "B"
                    ? gridColumns_demandPayoff_Borrower
                    : gridColumns_demandPayoff
                }
                columnData={Requested}
                status={status}
              />
            )}
            {activeTab === 1 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Payoff Pending Lender Approval"}
                gridColumns={
                  selectedRole === "B"
                    ? gridColumns_demandPayoff_Borrower
                    : gridColumns_demandPayoff
                }
                columnData={PendingApproval}
                status={status}
              />
            )}
            {activeTab === 2 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Approved Payoff"}
                gridColumns={
                  selectedRole === "B"
                    ? gridColumns_demandPayoff_Borrower
                    : gridColumns_demandPayoff
                }
                columnData={Approved}
                status={status}
              />
            )}
            {activeTab === 3 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Rejected Payoff"}
                gridColumns={
                  selectedRole === "B"
                    ? gridColumns_demandPayoff_Borrower
                    : gridColumns_demandPayoff
                }
                columnData={Rejected}
                status={status}
              />
            )}
          </section>
        </div>
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row mt-5">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
      {selectedRole === "L" && (
        <RequestPayOffModalLender
          payOffModal={showModal}
          setPayOffModal={setShowModal}
          refreshTable={() => setRefresh(!refresh)}
        />
      )}
      {selectedRole === "B" && (
        <RequestPayOffModal
          payOffModal={showModal}
          setPayOffModal={setShowModal}
          refreshTable={() => setRefresh(!refresh)}
        />
      )}
    </div>
  );
};

export default DemandPayoff;

const tabButtons = (role) => [
  {
    label: "Requested Payoff",
    title: "Requested Payoff",
  },
  {
    label: "Payoff Pending Lender Approval",
    title: "Payoff Pending Lender Approval",
  },
  { label: "Approved Payoff", title: "Approved Payoff" },
  { label: "Rejected Payoff", title: "Rejected Payoff" },
];
